import * as React from 'react'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/DeleteOutlined'
import PreviewIcon from '@mui/icons-material/Preview'
import {
  DataGrid,
  GridColDef,
  GridActionsCellItem,
  GridRowId,
  GridToolbar,
} from '@mui/x-data-grid'
import { useNavigate } from 'react-router-dom'
import { SubscriptionModel } from 'types'
import axios from 'axios'
import { base_url } from 'env'
import { Box } from '@mui/material'
import SearchBar from './SearchBar'
import ExportButton from './ExportButton'

const searchFields = [
  { value: 'name', label: 'Nom' },
  { value: 'price', label: 'Prix (€)' },
  { value: 'nbOfSubscribers', label: 'Abonnés' },
]

export default function SubscriptionDataGrid({
  subscriptions,
}: {
  subscriptions: SubscriptionModel[]
}) {
  const [rows, setRows] = React.useState(subscriptions)
  const navigate = useNavigate()

  React.useEffect(() => {
    setRows(subscriptions)
  }, [subscriptions])

  const handleDeleteClick = (id: GridRowId) => () => {
    if (window.confirm(`Êtes-vous sûr de vouloir supprimer cet abonnement ?`)) {
      const token = localStorage.getItem('token')
      axios
        .delete(`${base_url}/subscription/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then(() => setRows(rows.filter((row) => row.id !== id)))
        .catch((err) => alert('La suppression a échoué.'))
    }
  }

  const columns: GridColDef[] = [
    { field: 'name', headerName: 'Nom', flex: 1, minWidth: 200 },
    { field: 'price', headerName: 'Prix (€)', type: 'number', width: 130 },
    {
      field: 'nbOfSubscribers',
      headerName: 'Abonnés',
      type: 'number',
      width: 130,
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: 'Actions',
      width: 120,
      cellClassName: 'actions',
      getActions: ({ id }) => [
        <GridActionsCellItem
          icon={<PreviewIcon />}
          label="Preview"
          onClick={() => navigate(`/subscription/${id}`)}
          color="inherit"
        />,
        <GridActionsCellItem
          icon={<EditIcon />}
          label="Edit"
          onClick={() => navigate(`/subscription/${id}/edit`)}
          color="inherit"
        />,
        <GridActionsCellItem
          icon={<DeleteIcon />}
          label="Delete"
          onClick={handleDeleteClick(id)}
          color="inherit"
        />,
      ],
    },
  ]

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          margin: '1rem',
          gap: '1rem',
        }}
      >
        <SearchBar
          onSearch={setRows}
          fields={searchFields}
          originalData={subscriptions}
        />
        <ExportButton
          fields={[
            'id',
            'name',
            'price',
            'nbOfSubscribers',
            'maxProfiles',
            'maxLicenses',
          ]}
          data={subscriptions}
          exportFileName="subscriptions_export"
        />
      </Box>
      <DataGrid
        rows={rows}
        columns={columns}
        slots={{ toolbar: GridToolbar }}
        initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
        pageSizeOptions={[10, 25, 50]}
      />
    </Box>
  )
}
